import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { Tooltip, InfoIcon } from 'components';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';
import classNames from 'classnames';

export class TextField extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    label: PropTypes.string,
    type: PropTypes.string,
    maxLength: PropTypes.number,
    colorError: PropTypes.bool,
    tooltipInfo: PropTypes.string,
    tooltipWidth: PropTypes.string,
    tooltipType: PropTypes.string,
    tooltipFor: PropTypes.string,
    rightPanel: PropTypes.node,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    columnsCount: 1,
    label: '',
    type: 'text',
    maxLength: null,
    rightPanel: null,
    disabled: false,
  };

  render() {
    const {
      input,
      label,
      type,
      placeholder,
      maxLength,
      tooltipInfo,
      tooltipFor,
      tooltipWidth,
      tooltipType,
      rightPanel,
      disabled,
      verifyField,
      autoComplete = 'off',
      isPatientForm,
      meta,
    } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <div className="input-component">
          {label && <span className="input-component__label">{label}</span>}
          <input
            value={input.value}
            type={type}
            placeholder={placeholder}
            onFocus={input.onFocus}
            onChange={(value) => input.onChange(value)}
            onBlur={input.onBlur}
            maxLength={maxLength}
            name={input.name}
            autoComplete={autoComplete}
            disabled={disabled}
            className={classNames('form-control', {
              error: meta?.touched && meta?.error,
              disabled: disabled,
            })}
            style={{
              fontSize: verifyField && disabled ? '12px' : undefined,
              color: verifyField && disabled ? '#8A929B' : undefined,
              cursor: disabled ? 'not-allowed' : undefined,
              opacity: disabled ? 0.7 : undefined,
            }}
          />
          <div className="input-component__right-panel">
            {rightPanel}
            {tooltipInfo && tooltipFor === 'field' && (
              <Tooltip
                style={{ height: '15px', marginLeft: '5px' }}
                width={tooltipWidth}
                type={tooltipType}
                info={tooltipInfo}
              >
                <InfoIcon width="15px" height="15px" />
              </Tooltip>
            )}
          </div>
        </div>
      </ReduxFormElementWrapper>
    );
  }
}
